import React, {Component} from "react"
import { Nav, Navbar, Button, NavDropdown } from 'react-bootstrap'

class Header extends Component {
	constructor () {
		super()
		this.state = {}
	}

	render () {
		return(
			<Navbar className="header" expand="lg" sticky="top">
			  <Navbar.Brand href="/"><span className="whiteText logoText">Oja<span className="yellow">.</span></span></Navbar.Brand>
			  <Navbar.Toggle aria-controls="basic-navbar-nav" />
			  <Navbar.Collapse id="basic-navbar-nav">
			    <Nav className="ml-auto">
			      <Nav.Link href="/login" className="whiteText">Login</Nav.Link>
			      <Nav.Link href="/signup" className="whiteText">Register</Nav.Link>
			      <NavDropdown title={<span className="whiteText">More</span>} id="basic-nav-dropdown">
			        <NavDropdown.Item href="#">About Platform</NavDropdown.Item>
			        <NavDropdown.Item href="#">FAQs</NavDropdown.Item>
			        <NavDropdown.Item href="#">Contact Us</NavDropdown.Item>
			        <NavDropdown.Divider />
			        <NavDropdown.Item href="#">Suggest a feature</NavDropdown.Item>
			      </NavDropdown>
			    </Nav>
			      
			  </Navbar.Collapse>
			  <Button className="btn-primary">Post Your Ad</Button>
			</Navbar>
		)
	}
}

export default Header